import React, { useEffect } from 'react';
import { Route, Routes, useLocation } from 'react-router-dom';
import SmsList from './SmsList.tsx';
import SendSmsForm from './SendSmsForm.tsx';
import CreateSms from './CreateEditSms.tsx';
import CreateEditSms from './CreateEditSms.tsx';
import SmsLog from './SmsLog.tsx';



const SmsRoutes = () => {
    return (
        <>
            <Routes>
                <Route path={'/list'} element={<SmsList />} />
                <Route path={'/send'} element={<SendSmsForm />} />
                <Route path={'/create'} element={<CreateEditSms />} />
                <Route path={'/edit/:Id'} element={<CreateEditSms />} />
                <Route path={'/logs'} element={<SmsLog />} />
            </Routes>
        </>
    );
};
export default SmsRoutes;
